import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default () => (
  <SvgIcon>
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.7353 22.2034C12.3394 22.6326 11.6614 22.6326 11.2654 22.2035L2.62586 12.8407C1.80195 11.9853 1.25816 10.882 1.0716 9.68744C0.885051 8.49285 1.06521 7.26755 1.58652 6.18532C1.97963 5.36864 2.55387 4.66069 3.26192 4.11982C3.96998 3.57895 4.79159 3.22063 5.65906 3.07439C6.52653 2.92815 7.41502 2.99817 8.25133 3.27869C9.08765 3.55921 9.84785 4.04219 10.4693 4.68784L12.0004 6.27777L13.5316 4.68784C14.153 4.04219 14.9132 3.55921 15.7495 3.27869C16.5858 2.99817 17.4743 2.92815 18.3418 3.07439C19.2093 3.22063 20.0309 3.57895 20.7389 4.11982C21.447 4.66069 22.0212 5.36864 22.4143 6.18532C22.9349 7.26713 23.1148 8.4917 22.9284 9.68561C22.7421 10.8795 22.199 11.9823 21.376 12.8376L12.7353 22.2034Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  </SvgIcon>
);
